import { useCallback } from "react";
import styles from "./styles.module.scss";

interface SwitchProps {
  checked: boolean;
  onClick?: () => void;
}

const Switch = ({ checked, onClick }: SwitchProps) => {
  const onChangeHandler = useCallback(() => {
    onClick?.();
  }, [onClick]);

  return (
    <label className={styles.Switch}>
      <input type="checkbox" checked={checked} onChange={onChangeHandler} />
      <span className="slider"></span>
    </label>
  );
};

export default Switch;
